import React, { useEffect, useState } from 'react'
import { SvgSuccessToast, SvgCross, SvgErrorToast } from '../assets/images'

interface ToastProps {
  message: string
  type: 'success' | 'error' | 'info' | 'warning'
  onClose: () => void
}

const Toast: React.FC<ToastProps> = ({ message, type, onClose }) => {
  const [isVisible, setIsVisible] = useState<boolean>(false)

  useEffect(() => {
    setIsVisible(true)

    const timer = setTimeout(() => {
      setIsVisible(false)
      setTimeout(onClose, 500)
    }, 3000)

    return () => clearTimeout(timer)
  }, [onClose])

  const toastClasses = `flex p-4 gap-4 border-2 rounded-lg shadow-md sm:!w-[25rem] w-[18rem] transition-all duration-500 transform items-center ${
    isVisible ? '-translate-x-6' : 'translate-x-full'
  }`

  return (
    <div
      className={`${toastClasses} ${
        type === 'success'
          ? 'bg-success-25 border-success-300'
          : ' bg-red-50 border-error-300'
      }`}
    >
      <div
        className={`p-2 rounded-md ${
          type === 'success' ? 'bg-success-700' : 'bg-error-400'
        }`}
      >
        {type === 'success' ? <SvgSuccessToast /> : <SvgErrorToast />}
      </div>
      <div className="flex w-full justify-between items-center">
        <div className="font-primary text-xs font-light">{message}</div>
        <div className="cursor-pointer" onClick={() => setIsVisible(false)}>
          <SvgCross />
        </div>
      </div>
    </div>
  )
}

export default Toast
